module.exports = __webpack_public_path__ + "static/media/thumbnail.c85f6bdf.jpg";